import { useState } from 'react';
import {
  FiArrowUpRight,
  FiFileText,
  FiFolder,
  FiGrid,
  FiLogOut,
  FiMenu,
  FiUser,
  FiX,
} from 'react-icons/fi';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import styles from './AdminLayout.module.css';

const navigation = [
  { to: '/admin', label: 'Dashboard', icon: FiGrid, end: true },
  { to: '/admin/posts', label: 'Articles', icon: FiFileText },
  { to: '/admin/projects', label: 'Projects', icon: FiFolder },
  { to: '/admin/profile', label: 'Profile', icon: FiUser },
];

const pageNames = {
  '/admin': 'Dashboard',
  '/admin/posts': 'Articles',
  '/admin/posts/new': 'New article',
  '/admin/projects': 'Projects',
  '/admin/projects/new': 'New project',
  '/admin/profile': 'Profile',
};

const AdminLayout = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const pageName = pageNames[location.pathname]
    || (location.pathname.includes('/posts/') ? 'Edit article' : 'Edit project');

  const logout = () => {
    localStorage.removeItem('token');
    navigate('/login', { replace: true });
  };

  return (
    <div className={styles.adminShell}>
      <aside className={`${styles.sidebar} ${menuOpen ? styles.sidebarOpen : ''}`}>
        <div className={styles.brand}>
          <span className={styles.brandMark}>C<span>.</span></span>
          <span>
            <strong>CodeCognition</strong>
            <small>ADMIN</small>
          </span>
        </div>

        <nav className={styles.navigation} aria-label="Admin navigation">
          {navigation.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) => isActive ? styles.active : undefined}
            >
              <Icon />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className={styles.sidebarFooter}>
          <a href="/" target="_blank" rel="noreferrer">
            <FiArrowUpRight /> View site
          </a>
          <button type="button" onClick={logout}>
            <FiLogOut /> Sign out
          </button>
          <div className={styles.profile}>
            <span>YC</span>
            <div><strong>Yi Chen</strong><small>Administrator</small></div>
          </div>
        </div>
      </aside>

      <div className={styles.workspace}>
        <header className={styles.topbar}>
          <button
            className={styles.menuButton}
            type="button"
            aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
            onClick={() => setMenuOpen((value) => !value)}
          >
            {menuOpen ? <FiX /> : <FiMenu />}
          </button>
          <div>
            <span>ADMINISTRATION</span>
            <strong>{pageName}</strong>
          </div>
        </header>
        <main className={styles.main}><Outlet /></main>
      </div>
    </div>
  );
};

export default AdminLayout;
